import {
  CalendarOutlined,
  CarryOutOutlined,
  CodeSandboxOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import { IUser } from "types/auth";
import {
  home,
  order,
  manageProduct,
  manageAgent,
  campaign,
  orders,
  logsetting,
  billing,
  money,
  pointManage,
  financeIcon,
  video,
  truck,
} from "assets/icons";

const menuIconStyle = { fontSize: 20, color: "#4D4D4D" };

export interface IMenu {
  title: string;
  path: string;
  icon: React.ReactNode;
  children?: IMenu[];
  permissionList: string[];
  key: string;
  style?: React.CSSProperties;
  iconStyle?: React.CSSProperties;
  isExternal?: boolean;
}

export const menuList: IMenu[] = [
  {
    title: "ภาพรวมร้านค้า",
    icon: home,
    path: "/dashboard",
    key: "1",
    permissionList: [],
  },
  {
    title: "สร้างคำสั่งซื้อสินค้า",
    icon: order,
    path: "/create-order",
    key: "2",
    permissionList: [],
  },
  {
    title: "คำสั่งซื้อ",
    icon: orders,
    path: "/order",
    key: "3",
    permissionList: [],
  },
  {
    title: "การจัดส่ง",
    icon: <CarryOutOutlined style={menuIconStyle} />,
    path: "/shipping",
    key: "5",
    permissionList: [],
  },
  {
    title: "พิมพ์ใบปะหน้าพัสดุ",
    icon: truck,
    path: "/print-shipping-label",
    key: "5-1",
    permissionList: [],
  },
  {
    title: "จัดการ Point",
    icon: pointManage,
    path: "/point-manage",
    key: "4",
    permissionList: [],
  },
  {
    title: "ฐานลูกค้า",
    icon: manageAgent,
    path: "/manage-agent",
    key: "6",
    permissionList: [],
  },
  {
    title: "ใบกำกับภาษี",
    icon: money,
    path: "/manage-taxinvoice",
    key: "7",
    permissionList: [],
  },
  {
    title: "รายรับและการถอนเงิน",
    icon: financeIcon,
    path: "/manage-finance",
    key: "8",
    permissionList: [],
  },
  {
    title: "สินค้าและสต็อก",
    icon: manageProduct,
    path: "/manage-product",
    key: "10",
    permissionList: [],
  },
  {
    title: "ส่งพัสดุทั่วไป",
    icon: <CodeSandboxOutlined style={menuIconStyle} />,
    path: "/manage-parcel",
    key: "5-2",
    permissionList: [],
  },
  {
    title: "เครดิตและพอยต์",
    icon: <WalletOutlined style={menuIconStyle} />,
    path: "/manage-credit",
    key: "5-3",
    permissionList: [],
  },
  {
    title: "การอบรม",
    icon: <CalendarOutlined style={menuIconStyle} />,
    path: "/training",
    key: "11",
    permissionList: [],
  },
  {
    title: "ตั้งค่าร้านค้า",
    icon: logsetting,
    path: "/setting",
    key: "9",
    permissionList: [],
  },


];

export const menuPermission = (user: IUser | null | undefined, menu: IMenu) => {
  if (!user) return false;

  const role = user.role?.name;

  if (!role) return false;

  if (menu.permissionList.includes(role)) {
    return true;
  }

  return false;
};
